import { render, staticRenderFns } from "./BottomTabs.vue?vue&type=template&id=751c17e0&scoped=true"
import script from "./BottomTabs.vue?vue&type=script&lang=js"
export * from "./BottomTabs.vue?vue&type=script&lang=js"
import style0 from "./BottomTabs.vue?vue&type=style&index=0&id=751c17e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751c17e0",
  null
  
)

export default component.exports